export default __webpack_public_path__ + "static/media/08_HJT.520163dd.png";